import styled from "styled-components";

export const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin-top: var(--space-2);
  font-size: var(--text-lg);
  font-weight: 600;

  .MuiButton-root {
    margin-left: auto;
  }
`;

export const TwoUp = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4) var(--space-3);

  @media screen and (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const DecksColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const DeckColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }
`;

export const DeckColumnHeader = styled.div<{ $dark?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  font-family: var(--font-display);
  font-weight: 600;
  background: ${({ $dark }) => ($dark ? "var(--night)" : "var(--card)")};
  color: ${({ $dark }) => ($dark ? "var(--night-ink)" : "var(--ink)")};
  border: var(--border-w) solid ${({ $dark }) => ($dark ? "var(--night-lip)" : "var(--ink)")};
`;

export const DeckOption = styled.button<{ $selected?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-3);
  text-align: left;
  font-family: var(--font-body);
  font-size: var(--text-sm);
  color: var(--ink);
  background: ${({ $selected }) => ($selected ? "var(--teal-tint)" : "var(--card)")};
  border: var(--border-w) solid ${({ $selected }) => ($selected ? "var(--teal)" : "var(--line)")};
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background var(--dur-fast), border-color var(--dur-fast), transform var(--dur-fast) var(--ease-bounce);

  &:active {
    transform: scale(0.98);
  }

  span {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  b {
    font-weight: 800;
  }

  small {
    color: var(--ink-soft);
    font-size: var(--text-xs);
    font-weight: 600;
  }
`;

export const DeckCheck = styled.span<{ $selected?: boolean }>`
  display: grid !important;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: var(--radius-sm);
  border: var(--border-w) solid ${({ $selected }) => ($selected ? "var(--ink)" : "var(--line-strong)")};
  background: ${({ $selected }) => ($selected ? "var(--teal)" : "var(--card)")};
  color: var(--ink);
`;
